/**
 * GraphQL adds the typenames to the data and when we send it back like that GraphQL doesn't like it
 * Remove the typename fields in case they are still left over before saving
 * @param  {any} value  Anything that needs the typename field removed
 * @return {any}        Whatever value was minus the typename fields
 */

export default function removeTypenamesAndPublished(value, removePublished = false) {
  if (Array.isArray(value)) return value.map((v) => removeTypenamesAndPublished(v, removePublished))
  if (value !== null && typeof value === 'object') {
    const newObject = {}
    // eslint-disable-next-line no-restricted-syntax
    for (const property of Object.keys(value))
      if (property !== '__typename' && property !== 'published')
        newObject[property] = removeTypenamesAndPublished(value[property], removePublished)
      else if (property === 'published' && !removePublished)
        newObject[property] = removeTypenamesAndPublished(value[property], removePublished)

    return newObject
  }
  return value
}
